export default "__VITE_ASSET__5882287a__"